import { useFetchCreditsBalance } from "../../hooks/useFetchCreditsBalance";
import { SEARCH_MAX_PROPERTIES } from "../../../../constants/neighborhoodSearch";
import { SearchResultsCard, ErrorResults, NoMatchingResults } from "./SharedComponents";
import { MatchingResults } from "./MatchingResults";


export interface RegionSearchResultsProps {
  searchName: string;
  onSearchNameChange: (searchName: string) => void;
  onSaveSearchClick: (payload: { searchName: string }) => void;
  numProperties: number;
  isSaving?: boolean;
  isFetching?: boolean;
  error?: Error | null;
  isError?: boolean;
  onClearSearchClick: () => void;
}

export const RegionSearchResults = ({
  searchName,
  onSearchNameChange,
  onSaveSearchClick,
  onClearSearchClick,
  numProperties,
  isSaving = false,
  isFetching = false,
  error = null,
  isError = false,
}: RegionSearchResultsProps) => {
  const { data: creditsData } = useFetchCreditsBalance();
  const availableCredits = creditsData?.balance;
  const formattedCredits = creditsData?.formattedBalance;

  const hasMatchingResults = (
    <MatchingResults
      title={`${numProperties} properties found`}
      creditCost={numProperties}
      availableCredits={availableCredits ?? null}
      formattedCredits={formattedCredits}
      isFetching={isFetching}
      searchName={searchName}
      onSearchNameChange={onSearchNameChange}
      onSaveSearchClick={() => onSaveSearchClick({ searchName })}
      onClearSearchClick={onClearSearchClick}
      isSaving={isSaving}
    />
  );

  // Show skeleton when fetching and no properties yet
  if (isFetching && numProperties === 0) {
    return <SearchResultsCard showSkeleton={true} />;
  }

  return (
    <SearchResultsCard>
      {isError ? (
        <ErrorResults error={error} isFetching={isFetching} onClearSearchClick={onClearSearchClick} />
      ) : !numProperties ? (
        <NoMatchingResults
          title="No Properties Found"
          message="No properties found matching your criteria. Try increasing your search area or editing your filters"
          isFetching={isFetching}
          onClearSearchClick={onClearSearchClick}
        />
      ) : numProperties > SEARCH_MAX_PROPERTIES ? (
        <NoMatchingResults
          title="Too Many Properties"
          message={`Your search returned more than ${SEARCH_MAX_PROPERTIES} properties. Please narrow your search area or apply additional filters.`}
          isFetching={isFetching}
          onClearSearchClick={onClearSearchClick}
        />
      ) : (
        hasMatchingResults
      )}
    </SearchResultsCard>
  );
};
